<div class="main-container" (document:click)="handleOutsideClick($event)">
  <input class="input input-text" (ngModelChange)="onInput($event)" [(ngModel)]="destination" [placeholder]="placeHolder" [disabled]="disabled">
  <div class="results-main-container">
    <div *ngIf="predictions.length > 0">
      <div class="result-item" *ngFor="let prediction of predictions" (click)="selectPrediction(prediction)">
        {{ prediction.description }}
      </div>
    </div>
  </div>
</div>

